module.exports = __webpack_public_path__ + "img/Rail_saf_1.42b47da5.jpg";